import * as React from 'react'
import { IProgramServiceMembership } from '../../types/membership'
import TableRow from './TableRow'

export interface IProcessedRequestsTable {
  items: IProgramServiceMembership[]
  onToggleMembershipModal: (item: IProgramServiceMembership) => void
  getMembershipProcessedRequests: (organizationId: string) => void
  currentOrgId?: string
}

class ProcessedRequestsTable extends React.Component<IProcessedRequestsTable> {
  public componentDidMount() {
    if (this.props.currentOrgId) {
      this.props.getMembershipProcessedRequests(this.props.currentOrgId)
    }
  }

  public render() {
    if (!this.props.currentOrgId) {
      return null
    }

    return (
      <div>
        <div className='flex col-12 h6 font-grey2 px2 border-box'>
          <div className='Col col-2'>Basic Info</div>
          <div className='Col col-2'>Phone number</div>
          <div className='Col col-1'>Mobility</div>
          <div className='Col col-2'>Organization</div>
          <div className='Col col-1'>Service</div>
          <div className='Col col-2'>Requested</div>
          <div className='Col col-1'>Status</div>
        </div>
        {this.props.items.map(item => (
          <TableRow key={item.id} item={item} />
        ))}
      </div>
    )
  }
}

export default ProcessedRequestsTable



// WEBPACK FOOTER //
// ./src/components/membership-request/ProcessedRequestsTable.tsx